<template>
  <div >
    <el-form :model="userInfo" :rules="rules" ref="userInfo" class="infoForm">
        <el-form-item class="infoInput" prop="personNo">
            <el-input v-model="userInfo.personNo" placeholder="学工号"  maxlength="25"></el-input>
        </el-form-item>
        <el-form-item class="infoInput" prop="name">
            <el-input v-model="userInfo.name" placeholder="姓名"  maxlength="25"></el-input>
        </el-form-item>
       <send-code ref="getPhoneInfo" @submitRegForm="getIdentity('userInfo')" :code-info="codeInfo"></send-code>

        <el-form-item class="infoBtn">
          <el-button type="primary" @click="getIdentity('userInfo')">验证身份</el-button>
        </el-form-item>
    </el-form>
  </div>
</template>

<script>
  import {checkName,checkCode,checkStudentId} from '../../../config/formCheck'
  import SendCode from '../../../public/sendCode'
export default {
  name: "infoForm",
    components: {
      sendCode:SendCode
    },
  data() {
    return {
      userInfo: {
        personNo:"",
        name:"",
        token:"",
        phoneNo:""
      },
      codeInfo:{
          errorMsg:""
        },
       rules: {
          student_name: [
            { validator: checkName, trigger: 'change' }
          ],
          student_id: [
            { validator: checkStudentId, trigger: 'change' }
          ]
        },
    };
  },
  methods: {
      //验证身份
      getIdentity(userInfo){
        let self = this
         self.$refs[userInfo].validate((valid) => {
          if (valid) {
            self.$refs['getPhoneInfo'].validatePhone((valid)=>{
              if(valid){
                const loading = self.$loading({
                  lock: true,
                  text: '正在验证中...',
                  spinner: 'el-icon-loading',
                  background: 'rgba(0, 0, 0, 0.7)'
                });
                self.codeInfo.errorMsg =""
                const phoneInfo = self.$refs.getPhoneInfo.phoneInfo
                const personNo = self.userInfo.personNo
                const phoneNo = phoneInfo.phone
                const name = self.userInfo.name
                const msgCode = phoneInfo.code
                const url = '/email/identificationPhone?phoneNo='+phoneNo+'&code='+msgCode+'&sno='+personNo+'&name='+name
                self.getRequest(url).then((result)=>{
                    console.log("验证身份：",result.data)

                    loading.close();
                    if(result.data){
                      if(result.data.msgStatus == "1" || result.data.msgStatus == "5"){
                        // 未注册
                        // const _data = JSON.parse(result.data.data)
                        // console.log("_data",_data)
                        // sessionStorage.setItem("officeEmail_phoneNo",phoneNo)
                        // sessionStorage.setItem("officeEmail_token",result.data.msgCode)
                        // sessionStorage.setItem("officeEmail_userInfo",JSON.stringify(_data.data))
                        // if(_data.data.sids.indexOf(",") == "-1"){
                        //   self.$router.push({ name: 'RegOfficialEmail'})
                        // }else{
                        //   self.$router.push({ name: 'UserInfo'})
                        // }
                      // 临时修改  20210316
                      sessionStorage.setItem("officeEmail_token",result.data.msgCode)
                      sessionStorage.setItem("officeEmail_phoneNo",phoneNo)
                      sessionStorage.setItem("officeEmail_name",name)
                      sessionStorage.setItem("officeEmail_personNo",personNo)
                      sessionStorage.setItem("officeEmail_userInfo",JSON.stringify(result.data.data))
                      if(result.data.msgStatus == "1" ){
                       self.$router.push({ name: 'RegOfficialEmail'})
                      }

                      if(result.data.msgStatus == "5"){
                       self.$router.push({ name: 'UserInfo'})
                      }

                      }else if(result.data.msgStatus == "0"){
                        // 邮箱已注册
                         self.$alert("校友邮箱已注册", '错误提示', {
                          confirmButtonText: '确定',
                          dangerouslyUseHTMLString: true,
                          type: 'error',
                          center: true,
                          customClass:'errMessage'
                        });
                      }else if(result.data.msgStatus == "2"){
                        // 验证码错误
                         self.$alert(result.data.msgCode, '错误提示', {
                          confirmButtonText: '确定',
                          dangerouslyUseHTMLString: true,
                          type: 'error',
                          center: true,
                          customClass:'errMessage'
                        });
                      }else if( result.data.msgStatus == "3" ){
                        // 在校学生
                         sessionStorage.setItem("officeEmail_token",result.data.msgCode)
                         sessionStorage.setItem("officeEmail_phoneNo",phoneNo)
                         sessionStorage.setItem("officeEmail_personNo",personNo)
                         self.$router.push({ name: 'QrCode'})
                      }else{
                        self.$alert("系统错误，请稍后再试", '错误提示', {
                          confirmButtonText: '确定',
                          type: 'error',
                          center: true,
                          customClass:'errMessage'
                        });
                      }
                    }
                })
              }
            })
          } else {
            console.log('error submit!!');
            return false;
          }
        });
        //
      },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.infoForm {
  margin-top: 38px;
}
.infoInput {
  width: 308px;
  height: 41px;
  margin: 0 auto;
  margin-top: 18px;
}
  .infoBtn{
    margin: 0 auto;
    margin-top: 20px;
    text-align: center;
  }
  .infoBtn button{
    width: 310px;
  }
</style>



// WEBPACK FOOTER //
// src/page/officialEmail/checkPhone/infoForm.vue